import React, {useEffect} from "react";
import Link from "next/link";
import {Button, ListItem, ListItemText} from "@material-ui/core";
import {observer} from "mobx-react-lite";
import {useAuth} from "../util/auth";
import {characterStore} from "../utils/characters";

// Load the signed-in reader's characters once, so the menu and the story pages know whether to offer them
export function useLoadCharacters() {
    const auth = useAuth();
    const userId = auth && auth.user ? auth.user.uid : null;
    useEffect(() => {
        characterStore.load(userId);
    }, [userId]);
}

export const CharactersDrawerItem = observer(() => characterStore.enabled ? (
    <Link href="/characters" passHref>
        <ListItem component="a" button={true}>
            <ListItemText primary="Characters"/>
        </ListItem>
    </Link>
) : null);

// "Characters" in the top bar, beside the other story links
export const CharactersNavButton = observer(({className}: {className?: string}) => characterStore.enabled ? (
    <Link href="/characters" passHref>
        <Button component="a" className={className}>Characters</Button>
    </Link>
) : null);
